import Component from "@tunnel-components/@pages/incidents/fiche/component";
import * as React from "react";
import * as Utils from "@Cyclope-Utils/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";
// import * as moment from 'moment';
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next";
import {
  TunnelWatchOneCameraLoadedActionCreator,
  GetCameraBeforeAndAfterByLocationActionCreator,
  ExtractorVideoActionCreator,
  ImpactIsQualifiedActionCreator,
  ExtractorPdfIncidentActionCreator,
  ReplayDownloadActionCreator,
  ReplayActionCreator,
  sectionzonesloadedactioncreator,
  IncidentTypesLoadedActionCreator,
  ImpactIsReQualifiedActionCreator,
} from "@tunnel-store/index";
// import * as html2canvas from "html2canvas";
// import * as jsPDF from 'jspdf';

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChangeSource
 * @name onQualified
 * @name onExportPDF
 * @name onExportSequence
 * @name onDirectActive
 * @name onOpenhoverCard
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { array }      state.direct
     * @property { boolean }    state.btnloading
     * @property { boolean }    state.errorserver
     * @property { boolean }    state.loading
     * @property { boolean }    state.openHoverCard
     * @property { string }     state.incident
     * @property { any }        state.starttime
     */
    this.state = {
      actionFalseAlarmPatterns: false,
      actionFalseAlarmPatternsError: false,
      actionSeaPatterns: false,
      btnloading: false,
      data: {},
      dataCar: [
        i18next.t("voie de gauche"),
        i18next.t("voie de droite"),
        i18next.t("parking"),
        i18next.t("bau"),
        i18next.t("trottoir"),
      ],
      direct: [],
      errorExportPdf: false,
      errorExtractSequence: false,
      errorserver: false,
      identifiantActifSea: { id: 0 },
      incident: this.props.match.params.incident,
      loading: false,
      openHoverCard: false,
      // positionVehicule:,

      selectedOptionsIncident: [],
      selectedValue: "",
      starttime: "",
      viewSnapshotBoolean: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChangeSource = this.onChangeSource.bind(this);
    this.onQualified = this.onQualified.bind(this);
    this.onExportPDF = this.onExportPDF.bind(this);
    this.onExportSequence = this.onExportSequence.bind(this);
    this.onDirectActive = this.onDirectActive.bind(this);
    this.onOpenhoverCard = this.onOpenhoverCard.bind(this);
    this.onClosehoverCard = this.onClosehoverCard.bind(this);

    // motif d'une fausse alarme
    this.onSubmitPatterns = this.onSubmitPatterns.bind(this);
    this.onSubmitSeaPatterns = this.onSubmitSeaPatterns.bind(this);
    this.onCloseSeaPatterns = this.onCloseSeaPatterns.bind(this);
    this.onChangePatterns = this.onChangePatterns.bind(this);
    this.onSearchValue = this.onSearchValue.bind(this);
    this.viewSnapshot = this.viewSnapshot.bind(this);
    // selectedValue={selectedValue} onSearchValue={onSearchValue}

    this.onClosePattern = this.onClosePattern.bind(this); // ok
  }

  /**
   * @method onClosePattern
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosePattern = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @description :
     * @name  actionFalseAlarmPatterns
     * @types boolean
     */
    const actionFalseAlarmPatterns: boolean = false;
    /**
     * @constant
     * @description :
     * @name  actionFalseAlarmPatternsError
     * @types boolean
     */
    const actionFalseAlarmPatternsError: boolean = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      actionFalseAlarmPatterns,
      actionFalseAlarmPatternsError,
    }));

    this.allCalleverySeconde(); //
  };

  /**
   * @method onOpenhoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenhoverCard = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ openHoverCard: true }));
  };

  /**
   * @method viewSnapshot
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public viewSnapshot = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      viewSnapshotBoolean: !this.state.viewSnapshotBoolean,
    }));
  };
  /**
   * @method onClosehoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosehoverCard = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ openHoverCard: false }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }

      if (!Lodash.isUndefined(nextProps.data)) {
        /**
         * @constant
         * @description :
         * @name  positionVehicule
         * @types string
         */
        if (nextProps.data.vehiclePosition !== null) {
          const positionVehicule: string = this.state.dataCar[
            Number(nextProps.data.vehiclePosition)
          ];

          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ positionVehicule }));
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ positionVehicule: null }));
        }

        {
          /** vérification de l'existence de l'élement  */
        }
        if (!nextProps.data.terminated) {
          this.props
            .GetCameraBeforeAndAfterByLocationActionCreator(
              Number(nextProps.data.camera.direction),
              Number(nextProps.data.camera.location)
            )
            .then(() => {
              if (
                !Lodash.isUndefined(this.props.data) &&
                !Lodash.isEmpty(this.props.data)
              ) {
                const date = new Date(nextProps.data.startTime);
                {
                  /** Empêcher la mutation du state */
                }
                this.setState((state: any) => ({
                  starttime: Utils.localDateFrenchFormat(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDay(),
                    date.getDate(),
                    date.getHours(),
                    date.getMinutes()
                  ),
                }));
              }
            });
        }
        /**
         * @constant
         * @description :
         * @name  identifiantActifSea
         * @types any
         */
        const identifiantActifSea: any = localStorage.getItem(
          "identifiantActifSea"
        );

        if (identifiantActifSea !== null) {
          const identificationJson = JSON.parse(identifiantActifSea);

          if (Lodash.isEqual(identificationJson.id, this.state.incident)) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any) => ({
              actionSeaPatterns: true,
              identifiantActifSea: {
                id: identificationJson.id,
              },
            }));
          }
        }
      }
    } else if (nextProps.dataSequenceError !== this.props.dataSequenceError) {
      if (!Lodash.isUndefined(nextProps.dataSequenceError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ errorExtractSequence: true }));
      }
    } else if (nextProps.dataPdfError !== this.props.dataPdfError) {
      if (!Lodash.isUndefined(nextProps.dataPdfError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ errorExportPdf: true }));
      }
    } else if (nextProps.itemslabelIncident !== this.props.itemslabelIncident) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.itemslabelIncident)) {
        this.setState((state: any) => ({
          selectedOptionsIncident: this.onSortDynamic(
            nextProps.itemslabelIncident
          ),
        }));
      }
    } else if (nextProps.downloadVideo !== this.props.downloadVideo) {
      if (!Lodash.isUndefined(nextProps.downloadVideo)) {
        {
          /** Empêcher la mutation du state */
        }

        this.setState((state: any) => ({ loading: false }));
      }
    } else if (nextProps.location !== this.props.location) {
      window.location.reload(false);
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    // Zomm centrée image incident
    // window.location.reload()

    /**
     * @constant
     * @description :
     * @name  direct
     * @types boolean[]
     */
    const direct: any = [true, false];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ direct }));

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ loading: true }));

    {
      /** Action creator: La liste des types  d'incidents */
    }
    this.props.IncidentTypesLoadedActionCreator();

    {
      /** Action creator: La liste des types  d'incidents */
    }
    this.props
      .TunnelWatchOneCameraLoadedActionCreator(this.state.incident)
      .then(() => this.props.ReplayActionCreator(this.state.incident))
      .then(() => this.setState((state: any) => ({ loading: false })));

    const identifiantActifSea: any = localStorage.getItem(
      "identifiantActifSea"
    );

    if (identifiantActifSea !== null) {
      const identificationJson = JSON.parse(identifiantActifSea);
      if (Lodash.isEqual(identificationJson.id, this.state.incident)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          actionSeaPatterns: true,
          identifiantActifSea: {
            id: identificationJson.id,
          },
        }));
      }
    }

    {
      /** Handle page visibility change */
    }
    this.allCalleverySeconde(); // requete toutes les 3 secondes

    if (window.localStorage.getItem("fluxparamLive")) {
      /**
       * @constant
       * @name direct
       * @type boolean[]
       */
      {
        /** vérification de l'existence de l'élement  */
      }
      for (let i = 0; i < Math.ceil(this.state.direct.length); i++) {
        direct.push(false);
      }

      direct[0] = true; // Changement de la valeur du tableau!!!

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ direct })); // Cloner la valeur du State
    }
  }
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name allCalleverySeconde
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public allCalleverySeconde = (): void => {
    {
      /** Handle page visibility change */
    }

    if (document.addEventListener) {
      /**
       * @constant
       * @name visProp
       * @type any
       */
      const visProp: any = Utils.getHiddenProp();
      /**
       * @constant
       * @name evtName
       * @type any
       */
      const evtName: any =
        visProp.replace(/[H|h]idden/, "") + "visibilitychange";

      document.addEventListener(evtName, this.onCheckEvent, false); // suppressionn de l'event
    }

    {
      /** initialisation de la requetes: vérification des incidents */
    }
    this.onCheckEvent();
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onCheckEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onCheckEvent = (): void => {
    const visProp = Utils.getHiddenProp();

    if (document[visProp]) {
      clearInterval(this.state.countInterval);
      {
        /** Empêcher la mutation du state ; avec une temps d'exécution */
      }
      this.setState((state: any) => ({ countInterval: null }));
    } else {
      {
        /** Appel de l'api */
      }
      {
        /** Empêcher la mutation du state ; avec une temps d'exécution */
      }
      this.setState((state: any) => ({
        countInterval: setInterval(() => {
          if (
            !Lodash.isUndefined(this.props.data) &&
            !this.props.data.terminated
          ) {
            this.props.TunnelWatchOneCameraLoadedActionCreator(
              this.state.incident
            );
          }
        }, 3000),
      }));
    }
  };
  /**
   * Changement d'etat de l'onglet Live et Replay
   * @public
   * @method
   * @name onDirectActive
   * @param { any  }  event
   * @param { number  }  param
   * @infos "https://reactjs.org"
   */
  public onDirectActive = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  direct
     * @types boolean[]
     */
    const direct: boolean[] = this.state.direct;

    {
      /** boucle  */
    }
    for (let i = 0; i < Math.ceil(this.state.direct.length); i++) {
      direct[i] = false;
    }

    direct[param] = true;

    if (param === 0) {
      if (!window.localStorage.getItem("fluxparamLive")) {
        // window.location.reload();
        window.localStorage.setItem("fluxparamLive", "0");
      }
    } else {
      window.localStorage.removeItem("fluxparamLive");
    }
    {
      /** Empêcher la mutation du state ; avec une temps d'exécution */
    }
    this.setState(direct);
  };
  /**
   * Changement des emplacement des vidéo
   * @public
   * @method
   * @name onChangeSource
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onChangeSource = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @description :
     * @name  changeSource
     * @types void
     */
    const changeSource = Utils.onChangeSourceAndTarget(event);
    /**
     * @constant
     * @description :
     * @name  targetElement
     * @types any
     */
    const targetElement: any = document.querySelector("#largeImage");
    /**
     * @constant
     * @description :
     * @name  SourceElement
     * @types any
     */
    const SourceElement: any = event.target.parentElement;
    {
      /** Changement des source au click de la souris */
    }
    Utils.onChangeTargetIncident(SourceElement, targetElement, changeSource);
  };
  /**
   * Extraction des incidents sous format Pdf
   * @public
   * @method
   * @name onExportPDF
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onExportPDF = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      loading: true,
      errorExtractSequence: false,
      errorExportPdf: false,
    }));

    this.props
      .ExtractorPdfIncidentActionCreator(this.props.match.params.incident)
      .then(() => this.setState((state: any) => ({ loading: false })));
  };
  /**
   * Changement des etats des inputs
   * @method onSearchValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSearchValue = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** vérification de l'existence de l'élement  */
    }
    if (!Lodash.isUndefined(this.props.itemslabelIncident)) {
      /**
       * @constant
       * @name selectedOptionsIncident
       * @type any[]
       */
      const selectedOptionsIncident: any[] = this.onSortDynamic(
        Utils.transformObjectToArray(this.props.itemslabelIncident)
      ).filter(
        (elem: any) =>
          i18next
            .t(`${elem.label}`)
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) !== -1
      );

      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        cameraIderror: false,
        error: false,
        errorserver: false,
        selectedOptionsIncident,
        selectedValue: event.target.value.trim(),
        simulation: false,
        typeincidenterror: false,
        typeincident: "",
      });
    }
  };
  /**
   * Extraction des incidents sous format vidéo
   * @public
   * @method
   * @name onExportSequence
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onExportSequence = (event: any): void => {
    // event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      loading: true,
      errorExtractSequence: false,
      errorExportPdf: false,
    }));

    {
      /**  test du type ou existance du paramètre */
    }
    if (this.props.data) {
      /**
       * @constant
       * @description :
       * @name  date
       * @types any
       */

      this.props
        .ReplayDownloadActionCreator(
          Number(this.props.data.id),
          this.props.data.label,
          this.props.data.startTime,
          this.props.data.camera.code
        )
        .then(() =>
          setTimeout(
            () => this.setState((state: any) => ({ loading: false })),
            2000
          )
        );
    }
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name removeEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public removeEvent = (): void => {
    clearInterval(this.state.countInterval); //
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ countInterval: null }));
    /**
     * @constant
     * @name visProp
     * @type any
     */
    const visProp: any = Utils.getHiddenProp();
    /**
     * @constant
     * @name evtName
     * @type any
     */
    const evtName: any = visProp.replace(/[H|h]idden/, "") + "visibilitychange";

    {
      /** suppression de l'event */
    }
    document.removeEventListener(evtName, this.onCheckEvent);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      btnloading: false,
      direct: [],
      errorExtractSequence: false,
      errorserver: false,
      loading: false,
      errorExportPdf: false,
    }));

    this.removeEvent(); //
  }
  /**
   * Qualification des incidents
   * @public
   * @method
   * @name onQualified
   * @param { number  }  id
   * @param { number  }  isQualify
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onQualified = (id: number, isQualify: number) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      errorExtractSequence: false,
      errorExportPdf: false,
    }));
    {
      /** comparaison du paramètres isQualify */
    }
    if (isQualify === -1) {
      /**
       * @constant
       * @description :
       * @name  actionFalseAlarmPatterns
       * @types boolean
       */
      const actionFalseAlarmPatterns: boolean = true;

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ actionFalseAlarmPatterns }));

      this.removeEvent(); //
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ loading: true }));

      {
        /** Action creator */
      }
      this.props
        .ImpactIsQualifiedActionCreator(id, isQualify)
        .then(() =>
          this.props.TunnelWatchOneCameraLoadedActionCreator(
            this.state.incident
          )
        )
        .then(() => this.setState((state: any) => ({ loading: false })));
    }
  };
  /**
   * valider le type d'incidents
   * @public
   * @method
   * @name onSubmitPatterns
   * @param { any } event
   * @param { number } id
   * @infos "https://reactjs.org"
   */
  public onSubmitPatterns = (id: number, sea: any) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @description : retourne un objet ( utilisateur )
     * @const
     * @name User
     * @type { any  }
     */
    // const User: any = Utils.createdUserRoles();
    /**
     * @constant
     * @description :
     * @name  authorisation
     * @types boolean
     */
    // const authorisation: boolean = Utils.simpleAuthorizationIsAllowed(User,[Enums.AuthorizationRightsEnums.AFFICHAGESAE]);
    const authorisation: boolean = true;

    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      !Lodash.isUndefined(this.state.patternfalseAlarm) &&
      !Lodash.isEqual(this.state.patternfalseAlarm, "eudes")
    ) {
      /**
       * @constant
       * @description :
       * @name  actionFalseAlarmPatterns
       * @types boolean
       */
      const actionFalseAlarmPatterns: boolean = false;
      /**
       * @constant
       * @description :
       * @name  actionFalseAlarmPatternsError
       * @types boolean
       */
      const actionFalseAlarmPatternsError: boolean = false;

      if (!Lodash.isUndefined(sea) && !Lodash.isNull(sea)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ actionSeaPatterns: true }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ actionSeaPatterns: false }));
        {
          /** vérification de l'existence de la variable */
        }
        if (authorisation) {
          this.props
            .ImpactIsReQualifiedActionCreator(
              id,
              -1,
              Number(this.state.patternfalseAlarm)
            )
            .then(() =>
              this.props
                .TunnelWatchOneCameraLoadedActionCreator(this.state.incident)
                .then(() => this.props.ReplayActionCreator(this.state.incident))
                .then(() => this.setState({ identifiantActifSea: { id: 0 } }))
                .then(() => this.setState({ loading: false }))
            );
        }
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        actionFalseAlarmPatterns,
        actionFalseAlarmPatternsError,
      }));
    } else {
      /**
       * @constant
       * @description :
       * @name  actionFalseAlarmPatternsError
       * @types boolean
       */
      const actionFalseAlarmPatternsError: boolean = true;
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ actionFalseAlarmPatternsError }));
    }
  };
  /**
   * Triage dans un tableau par ordre
   * @method onSortDynamic
   * @param { any[] }  Elem
   * @return { any []}
   * @infos "https://reactjs.org"
   */
  public onSortDynamic = (Elem: any): any => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.orderView > b.orderView ? 1 : b.orderView > a.orderView ? -1 : 0
      );
    }
  };
  /**
   * envoie vers le SEA
   * @public
   * @method
   * @name onSubmitSeaPatterns
   * @param { any } event
   * @param { number } id
   * @infos "https://reactjs.org"
   */
  public onSubmitSeaPatterns = (id: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  actionSeaPatterns
     * @types boolean
     */
    const actionSeaPatterns: boolean = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionSeaPatterns, loading: true }));
    /**
     * @description : retourne un objet ( utilisateur )
     * @const
     * @name User
     * @type { any  }
     */
    const User: any = Utils.createdUserRoles();
    /**
     * @constant
     * @description :
     * @name  authorisation
     * @types boolean
     */
    const authorisation: boolean = Utils.simpleAuthorizationIsAllowed(User, [
      Enums.AuthorizationRightsEnums.AFFICHAGESAE,
    ]);

    if (authorisation) {
      this.props
        .ImpactIsReQualifiedActionCreator(
          id,
          -1,
          Number(this.state.patternfalseAlarm)
        )
        .then(() =>
          this.props
            .TunnelWatchOneCameraLoadedActionCreator(this.state.incident)
            .then(() => this.props.ReplayActionCreator(this.state.incident))
            .then(() =>
              this.setState((state: any) => ({
                identifiantActifSea: { id: 0 },
              }))
            )
            .then(() => this.setState((state: any) => ({ loading: false })))
        );
    }
  };
  /**
   * ne pas envoyer vers le SEA
   * @public
   * @method
   * @name onCloseSeaPatterns
   * @param { any } event
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onCloseSeaPatterns = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  actionSeaPatterns
     * @types boolean
     */
    const actionSeaPatterns: boolean = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionSeaPatterns }));
  };
  /**
   * Manipulation  des inputs
   * @public
   * @method
   * @name onChangePatterns
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangePatterns(value: any) {
    /**
     * @constant
     * @description :
     * @name  actionFalseAlarmPatternsError
     * @types boolean
     */
    const actionFalseAlarmPatternsError: boolean = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      actionFalseAlarmPatternsError,
      patternfalseAlarm: value,
    }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** vérification de l'existence d'une variable */
    }

    // if(prevProps.data !== this.props.data){
    if (this.props.data && !Lodash.isUndefined(this.props.data)) {
      /**
       * @constant
       * @description :
       * @name  timelineIncident
       * @types any
       */
      // const timelineIncident: any = 32 + Utils.getCurrentIncidentTimeline(this.props.data.duration,this.props.data.camera.deltaExtraction);
      {
        /** Empêcher la mutation du state */
      }

      /**
       * @constant
       * @description : récuper l'identifiant du timeline
       * @name : seekTimeline
       */
      const Timeline = document.getElementById("incidentTimelineVideo");

      if (Timeline !== null) {
        Timeline.addEventListener(
          "timeupdate",
          ({ target }: any) => {
            if (this.props.data.camera) {
              // return target.currentTime / target.duration // à refaire cette règle!!! ce soir
              this.setState((state: any) => ({
                timelineIncident:
                  11.5 +
                  Math.round(
                    (this.props.data.camera.deltaExtraction *
                      target.videoWidth) /
                      target.duration
                  ) *
                    0.1,
              })); // 32px + 20px = 50px MAJ de la position du curseur : indication de l'heure de l'incident
            }
          },
          true
        );
      }
    }
    // }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    // zoom centrée souris
    Utils.zoomCenterMouse("#imageIncidentFile");

    return (
      <Component
        onExportSequence={this.onExportSequence}
        onChangeSource={this.onChangeSource}
        onExportPDF={this.onExportPDF}
        onQualified={this.onQualified}
        onDirectActive={this.onDirectActive}
        onOpenhoverCard={this.onOpenhoverCard}
        {...this.state}
        {...this.props}
        onSubmitPatterns={this.onSubmitPatterns}
        onSubmitSeaPatterns={this.onSubmitSeaPatterns}
        onCloseSeaPatterns={this.onCloseSeaPatterns}
        onChangePatterns={this.onChangePatterns}
        onSearchValue={this.onSearchValue}
        onClosehoverCard={this.onClosehoverCard}
        viewSnapshot={this.viewSnapshot}
        onClosePattern={this.onClosePattern}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  let incidentTypes;

  if (state.IncidentTypesLoaded.data) {
    incidentTypes = [...state.IncidentTypesLoaded.data];
    incidentTypes.push({
      id: -1,
      label: "NO_INCIDENT",
      labelFr: "NO_INCIDENT",
      orderView: 1,
    });
    incidentTypes.push({
      id: -2,
      label: "ER_CAMERA",
      labelFr: "ER_CAMERA",
      orderView: 2,
    });
  }

  return {
    cameraBeforeAfter: state.GetCameraBeforeAndAfterByLocation.data,
    data: state.TunnelWatchOneCameraLoaded.data,
    dataPdfdata: state.ExtractorPdfIncident.data,
    dataPdfError: state.ExtractorPdfIncident.error,
    dataSequenceError: state.ExtractorVideo.error,
    error: state.TunnelWatchOneCameraLoaded.error,
    getAllZone: state.SectionZonesLoaded.data,
    itemslabelIncident: incidentTypes,
    replayBlob: state.Replay.data,
    downloadVideo: state.ReplayDownload.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  ImpactIsReQualifiedActionCreator,
  IncidentTypesLoadedActionCreator,
  ReplayActionCreator,
  ExtractorPdfIncidentActionCreator,
  ExtractorVideoActionCreator,
  GetCameraBeforeAndAfterByLocationActionCreator,
  TunnelWatchOneCameraLoadedActionCreator,
  ImpactIsQualifiedActionCreator,
  sectionzonesloadedactioncreator,
  ReplayDownloadActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/fiche/container.tsx